// extracted by mini-css-extract-plugin
module.exports = {"tips":"tips_tips__2F0wf","tips_group":"tips_tips_group__2XWPP"};